import {
  Options,
  Splide,
  SplideSlide,
  SplideTrack
} from '@splidejs/react-splide'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

import Picture from '@/components/Picture'

import styles from './Carousel.module.scss'

const OPTIONS: Options = {
  arrows: false,
  type: 'loop',
  autoplay: true,
  interval: 3000,
  classes: {
    pagination: clsx('splide__pagination', styles['carousel__pagination']),
    page: clsx('splide__pagination__page', styles['carousel__page'])
  }
}

const SLIDES = [
  {
    id: 'automate',
    image: 'pic1.png'
  },
  {
    id: 'cashback',
    image: 'pic2.png'
  },
  {
    id: 'balance',
    image: 'pic3.png'
  },
  {
    id: 'reports',
    image: 'pic4.png'
  }
]

const Carousel: FC = () => {
  const { t, i18n: { language = 'en' } = {} } = useTranslation()

  return (
    <Splide options={OPTIONS} hasTrack={false} className={styles['carousel']}>
      <SplideTrack className={styles['carousel__track']}>
        {SLIDES.map(({ id, image }) => (
          <SplideSlide
            key={id}
            className={clsx(
              styles['carousel__slide'],
              styles[`carousel__slide_${id}`]
            )}
          >
            <div
              className={styles['carousel__heading']}
              dangerouslySetInnerHTML={{ __html: t(`about:benefits.${id}`) }}
            />
            <div className={styles['carousel__fig']}>
              <Picture
                src={`/images/carousel/${language}/${image}`}
                alt={''}
                className={styles['carousel__image']}
              />
            </div>
          </SplideSlide>
        ))}
      </SplideTrack>
    </Splide>
  )
}
export default Carousel
